import type {
    FC
} from "react";
import type ICommandSeparatorProps from "./type";

const CommandSeparator: FC<ICommandSeparatorProps> = () => {
    return null;
};
export default Object.assign(CommandSeparator, {
    commandPart: "separator"
});
